import { Churn } from '@modules/Admin/Flags/components/Churn/Churn';

const AtRiskStudents = () => (
  <div className="flex flex-col gap-6 p-8 font-raleway text-white">
    <div className="flex flex-col gap-1">
      <h1 className="text-2xl font-bold">Churn</h1>
    </div>
    <Churn />
  </div>
);

export default AtRiskStudents;
